/**
 * About Us Team Gallery – infinite scroll, stop on hover
 * Respects prefers-reduced-motion
 */
(function () {
  const galleries = document.querySelectorAll('[data-about-us-gallery]');
  if (!galleries.length) return;

  function init() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    galleries.forEach((gallery) => {
      if (prefersReducedMotion) {
        gallery.setAttribute('data-disabled', '');
      } else {
        gallery.removeAttribute('data-disabled');
      }
    });
  }

  init();
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', init);
})();
